// Static portfolio data
export const portfolioData = {
  profile: {
    name: "Triumph Ogeh",
    logo: "Triumph Ogeh",
    title: "Data Analytics & Program Management Professional",
    tagline: "I am a Data Analyst and Community Builder facinated by how data shapes narratives and changes lives. Over the past 5 years, I have contributed to high impact projects reaching 1 million+ people while building thriving innovation communities in underserved ecosystems.",
    bio: `I’m currently a Data Analyst in health tech, where I build data systems that support internal decision-making and public health awareness. Previously, I worked in oil & gas, building foundational analytics infrastructure that turned raw field data into insights for leadership teams.

Alongside my technical career, I’m a ecosystem operator. I lead the Google Developer Groups Akure, and have worked on international innovation programs across Africa and Europe including AfriConEU and S+T+ARTS4AFRICA.

Outside of work, I enjoy taking technical workshops, building community-driven programs, and travelling`,
    email: "triumph.ruth.ogeh@gmail.com",
    location: "San Francisco, CA",
    resumeUrl: "/resume.pdf",
    social: {
      linkedin: "https://linkedin.com/in/triumph-ogeh",
      github: "https://github.com/Triomphi",
      twitter: "https://x.com/ogehchee"
    }
  },

  skills: [
    "SQL & Python",
    "Program Management",
    "Tableau & Looker",
    "Monitoring & Evaluation",
    "Google Cloud",
    "Community Building",
    "Product Analytics",
    "Partnerships"
  ],

  experiences: [
    {
      title: "Data Analyst",
      company: "MDaaS",
      period: "2024 - Present",
      description: "Leading cross-functional teams to deliver enterprise analytics solutions. Managed $5M+ budget and 20+ stakeholders across multiple product lines.",
      achievements: [
        "Led population-level analysis of hypertension, diabetes, malaria, and antimicrobial resistance (AMR/MDR) trends across Nigeria, supporting evidence-based public health interventions and treatment policies.",
        "Built a social media health assistant powered by OpenAI and MedGamma APIs, providing automated symptom checks, patient education, documentation, and wellness guidance to thousands of users.",
        "Contributed to the design and optimization of data pipelines and schemas, enabling reliable, scalable healthcare analytics."
      ]
    },
    {
      title: "Hub Manager",
      company: "Akure Tech Hub",
      period: "2023 - 2024",
      description: "Built analytics infrastructure and led a team of 8 analysts. Developed predictive models and dashboards for executive decision-making.",
      achievements: [
        "Planned and executed the Akure Tech Hub Night School Bootcamp that trained over 70 youths in 6 months and placed 10% on internships.",
        "Managed the execution and promotion of the S+T+ARTS4AFRICA Project in Akure, Nigeria.",
        "Secured an EU-funded grant for Akure Tech Hub as a partner on the Erasmus+ UNVEIL Web 4.0 Entrepreneurship project, enabling its execution in Nigeria."
      ]
    },
    {
      title: "Programs & Communications Lead",
      company: "Emerging Communities Africa",
      period: "2022 - 2024",
      description: "Conducted data analysis to support product and marketing decisions. Collaborated with engineering teams to build data pipelines.",
      achievements: [
        "Planned and executed the AfriConEU Ambassadors program resulting in a 30% increase in participation on the AfriConEU project from 4 African countries.",
        "Planned and executed 5 capacity building programs and 1 international design thinking bootcamp in Nigeria under the AfriConEU project.",
        "Established partnerships with organizations to facilitate various tech and business focused training for the Hernovate community leading to a 25% increase in program visibility and reach.",
        "Leveraged data insights from Instagram, Twitter and Facebook to grow the organization's social accounts by 680%."
      ]
    },
    {
      title: "Data Analyst",
      company: "Pan Ocean Oil Corporation",
      period: "2022 - 2023",
      description: "Conducted data analysis to support product and marketing decisions. Collaborated with engineering teams to build data pipelines.",
      achievements: [
        "Developed and implemented a comprehensive data storage system for all oil assets, resulting in improved data organization and accessibility.",
        "Collaborated with cross-functional teams to develop standardized data entry procedures, resulting in a 50% reduction in data entry errors and ensuring accurate reporting for each oil asset.",
        "Developed and implemented a real-time oil production analytics dashboard using PowerBI, enabling stakeholders to easily identify inconsistencies and make data-driven decisions.",
        "Increased petroleum engineers efficiency by 30% by automating data collection, cleaning, and visualization processes for the oil production analytics dashboard."
      ]
    }
  ],

  projects: [
    {
      title: "Subscription Churn (Cohort Analysis)",
      category: "data",
      // description: "Analyzed subscription cohorts to understand weekly retention trends and identify when churn typically occurs for an e-learning platform.",
      technologies: ["Spreadsheet", "SQL"],
      // liveLink: "https://project-demo.com",
      githubLink: "https://github.com/Triomphi/Analytics-Projects/tree/main/Weekly%20Subscription%20Churn", // optional
      impact: "Reduced churn by 23% in Q1 2024",
      imageUrl: "./images/churn.png",
      featured: true
    },
    {
      title: "Reality TV Show (Sentiment Analysis)",
      category: "data",
      // description: "Web scraped and analyzed over 1 million tweets across a 3-month period to track viewer sentiment around the Big Brother Naija reality TV show.",
      technologies: ["Power BI", "Sentiment Analysis", "Python"],
      // liveLink: "https://project-demo.com",
      githubLink: "https://github.com/Triomphi/BBNaija-S7-Twitter-Analysis", // optional
      impact: "Saved 15 hours/week in manual reporting",
      imageUrl: "./images/BBN7.png",
      featured: true
    },
     {
      title: "Malaria Distribution in Nigeria",
      category: "data",
      // description: "Web scraped and analyzed over 1 million tweets across a 3-month period to track viewer sentiment around the Big Brother Naija reality TV show.",
      technologies: ["BigQuery", "Looker Studio"],
      liveLink: "https://www.beaconhealth.io/blogdetails/230380001477",
      // githubLink: "https://github.com/Triomphi/BBNaija-S7-Twitter-Analysis", // optional
      impact: "Saved 15 hours/week in manual reporting",
      imageUrl: "./images/Malaria.png",
      featured: true
    },
    {
      title: "RFM & Customer Segmentation",
      category: "data",
      // description: "This project focuses on performing RFM (Recency, Frequency, Monetary) analysis to identify customer segments and recommend actionable marketing strategies.",
      technologies: ["SQL", "Tableau"],
      // liveLink: "https://project-demo.com",
      githubLink: "https://github.com/Triomphi/Analytics-Projects/tree/main/CLV%20%26%20RFM%20Analysis", // optional
      impact: "$3.2M in annual cost savings identified",
      imageUrl: "./images/RFM.jpg",
      featured: false
    }
  ],

  speakingEngagements: [
    {
      title: "Designing Lightweight Data Pipelines on GCP",
      event: "DevFest Ibadan",
      date: "2025-11-29",
      location: "Ibadan, Nigeria",
      imageUrl: "./images/DevfestIbadan.JPG"
    },
    {
      title: "Building a Context-Aware AI with RAG on GCP",
      event: "DevFest Ado-Ekiti",
      date: "2025-11-14",
      location: "Ado-Ekiti, Nigeria",
      imageUrl: "./images/DevfestAdo.webp"
    },
    {
      title: "AI and Career Opportunities for Girls",
      event: "Girl Child Day - Tech Girls Club",
      date: "2025-10-10",
      location: "Ibadan, Nigeria",
      imageUrl: "./images/Techgirlsclub.jpeg"
    },
    {
      title: "The Power of Communities for Brands & Talents",
      event: "The Genesis Conference",
      date: "2025-09-20",
      location: "Akure Nigeria",
      imageUrl: "./images/Genesisconference.png"
    },
    {
      title: "Not Every Community Should Scale, Here’s Why",
      event: "GGD SSA Summit",
      date: "2025-05-30",
      location: "Accra, Ghana",
      imageUrl: "./images/GDGSummit.jpg"
    },
    {
      title: "Auto-Categorize Payment Receipt on GCP",
      event: "Build with AI",
      date: "2025-05-17",
      location: "Akure, Nigeria",
      imageUrl: "./images/BuildwithAI.jpg"
    },
    {
      title: "Building a Successful Enterprise from Campus",
      event: "Campus Innovation Summit",
      date: "2024-04-10",
      location: "Akure, Nigeria",
      imageUrl: "./images/CLISummit.png"
    },
    {
      title: "Collaboration & Mentorship: Building Networks for Success",
      event: "WeInspire Conference",
      date: "2024-04-04",
      location: "Akure, Nigeria",
      imageUrl: "./images/weinspire.png"
    },
    {
      title: "Untold Story of Being a Successful Freshman",
      event: "FUTA Student Union Freshers Meet",
      date: "2024-02-24",
      location: "Akure, Nigeria",
      imageUrl: "./images/Freshersmeet.jpeg"
    },
    {
      title: "Leveraging Technology to Build Thriving Businesses",
      event: "Founders' Square",
      date: "2023-03-31",
      location: "Akure, Nigeria",
      imageUrl: "./images/Founderssquare.JPG"
    },
    {
      title: "Navigating Your Journey To Start a Career In Tech",
      event: "Tech Expo",
      date: "2023-08-22",
      location: "Akure, Nigeria",
      imageUrl: "./images/TechExpo.png"
    },
    {
      title: "The Edge for Ladies in Tech",
      event: "Tech Posium, Cholatrek",
      date: "2021-06-14",
      location: "Akure, Nigeria",
      imageUrl: "./images/Techposium.png"
    }
  ],

  footprintStory: [
    {
      year: "2019",
      memories: [
        {
          // phase: "In the Beginning...",
          title: "In the Beginning...",
          description: `I started my tech journey with hardware engineering and embedded systems at TME Education, where I also volunteered to teach Arduino to kids in rural communities. 
          
          That same year, I joined the GDSC community and quickly became an active core team member. We organized our first Machine Learning Hackathon, sparking my love for community building and tech education.`,
          // milestone: "First major win: Identified $2M cost-saving opportunity through data analysis",
          imageUrl: "./images/2019.jpg"
        }
      ]
    },
    {
      year: "2020",
      memories: [
        {
          // phase: "Finding my Path",
          title: "Finding my Path",
          description: `Hardware engineering became financially unsustainable, so I pivoted into software and began learning data analytics at Coven Labs.`,
          // milestone: "Developed executive dashboard now used by C-suite daily",
          imageUrl: "./images/2020(1).jpg"
        },
        {
          // phase: "Growth",
          title: "COVID Escapades",
          description: `During COVID, I discovered my passion for organizing, planning, and executing programs. I applied to lead my student tech community and went on to run a series of online workshops, events, and training sessions throughout the pandemic. 

          I joined the Student Build Program, working on product research and systems thinking, and later joined the Hamoye internship, where I realized I preferred turning data into insights rather than building ML models. I went on to win Best Data Storytelling Intern.`,
          // milestone: "Mentored 5 junior analysts, 3 promoted within the year",
          imageUrl: "./images/2020(2).jpg"
        }
      ]
    },
    {
      year: "2021",
      memories: [
        {
          // phase: "Expansion",
          title: "Building Communities and Myself",
          description: `I organized our first community product hackathon in partnership with Founders Square, with teams across healthtech, proptech, logistics, and fintech. One of the teams later won the Wema Hackaholic Hackathon 3.0.

          After spending so much time helping others learn, I took a step back from community leadership to focus on building my own skills.`,
          // milestone: "Launched data platform serving 10K+ users",
          imageUrl: "./images/2021.JPG"
        }
      ]
    },
    {
      year: "2022",
      memories: [
        {
          // phase: "Impact",
          title: "Industry and Public Impact",
          description: `I secured my first internship in the oil & gas sector, where I helped build the foundation of their data and analytics system — transforming raw field data into insights for decision-makers.

          I also joined Emerging Communities Africa as a communications intern and unofficial assistant to the Special Adviser on Innovation and Partnerships to the Ondo State Governor. I was later retained full-time and went on to execute initiatives supporting businesses, youths, women, and children.

          Later that year, I returned to the tech ecosystem — this time at city level — and organized Akure’s first-ever DevFest.`,
          // milestone: "Speaking at 5 major industry conferences annually",
          imageUrl: "./images/2022.jpg"
        }
      ]
    },
    {
      year: "2023",
      memories: [
        {
          // phase: "Finding my Path",
          title: "Scaling Impact Across Borders",
          description: `I led stakeholder engagement for the AfriConEU project across 11 countries (4 in Africa, 7 in Europe) and was awarded at the project’s closing event in Portugal for my work in maximizing community strength.

          I joined the maiden edition of S+T+ARTS4AFRICA as an associated partner in Nigeria, supporting African artists in securing international residencies.`,
          // milestone: "Developed executive dashboard now used by C-suite daily",
          imageUrl: "./images/2023(1).jpg"
        },
        {
          // phase: "Growth",
          title: "A Taste of Management",
          description: `I became the first female and first undergraduate to lead Akure Tech Hub — Sub-Saharan Africa’s first tripartite innovation hub — where I launched the Night School program for busy adults and students.
          Alongside this, I freelanced as a data analyst.`,
          // milestone: "Mentored 5 junior analysts, 3 promoted within the year",
          imageUrl: "./images/2023(2).jpg"
        }
      ]
    },
    {
      year: "2024",
      memories: [
        {
          // phase: "Vision",
          title: "Full Circle with Data",
          description: `I made the decision to take my data career seriously again through the Digital Explorers program. Learning at Turing College reminded me why I fell in love with data in the first place.

          After my learning period, I joined a healthtech company as a data analyst — and later graduated from university.`,
          // milestone: "The journey continues...",
          imageUrl: "./images/2024.jpg"
        }
      ]
    },
    {
      year: "2025",
      memories: [
        {
          // phase: "Vision",
          title: "Data for Impact",
          description: `I began working deeply with health and diagnostic data, building internal analytics systems that supported clinical, operational, and business decisions.
          I became more intentional about public health awareness. I explored the trend of certain sicknesses in specific regions and how to make health information accessible to everyday people — especially in communities where misinformation is common and access to healthcare is limited.

          That journey led me to work on a WhatsApp health assistant designed to help people get trusted health information, guidance, and support directly from their phones.

          At the same time, I started stepping into more visible technical leadership. I began facilitating technical workshops at tech-focused events, sharing practical data skills and helping more people break into the field with confidence.`,
          // milestone: "The journey continues...",
          imageUrl: "./images/2025.jpg"
        },
        {
          // phase: "Vision",
          title: "Community Growth",
          description: `I also doubled down on community building through GDG. What started as a small local group grew into a stronger, more structured community — with more developers, more programs, and more real impact across the ecosystem.`,
          // milestone: "The journey continues...",
          imageUrl: "./images/2025(2).jpg"
        }
      ]
    }
  ],

  blogPosts: [
    {
      id: 1,
      title: "Beginners Guide to Grid Search for Hyper Parameter tuning",
      slug: "future-data-driven-decision-making",
      excerpt: "ML models uses two types of parameters, one to learn patterns in the data and the other to optimize the models performance.",
      content: "Full article content would go here...",
      date: "2020-08-22",
      link: "https://medium.com/@ruchix18/a-beginners-guide-to-using-grid-search-for-hyper-parameter-tuning-dd72ddd263f7",
      category: "Data Analytics",
      tags: ["AI", "Machine Learning", "Strategy"],
      imageUrl: "./images/Grid search.webp",
      featured: false
    }
  ]
};
